import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { stringFormatter } from '@nhl/formatter-utilities';
import { ReactTable } from '@nhl/nhl-breakaway-ui';

import { PlayerPosition } from '~/core/enums';
import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { awardsColumnsGoalie, awardsColumnsSkater } from '../../components/playerStats/columns';
import { PlayerSectionHeader } from '../../styles';
import { Player } from '../../types';

import { AwardsHeader, AwardsTable } from './styles';

type PlayerAwardsProps = {
    showAwards: boolean;
    player: Player;
};

export const PlayerAwards: FC<PlayerAwardsProps> = ({ player, showAwards }) => {
    const intl = useIntl();
    const cols = player?.position === PlayerPosition.goalie ? awardsColumnsGoalie(intl) : awardsColumnsSkater(intl);

    const awardList = player.awards.map((award, i) => {
        const awardSlug = stringFormatter.toSlug(award.trophy.default);

        return (
            <React.Fragment key={i}>
                <AwardsHeader $rowNumber={i} id={`${awardSlug}-award-name`}>
                    {parseValueFromLocalizedAttribute(award.trophy)}
                </AwardsHeader>
                <AwardsTable>
                    <ReactTable data={award.seasons} columns={cols} tableId={`${awardSlug}-award-table`} />
                </AwardsTable>
            </React.Fragment>
        );
    });

    return showAwards ? (
        <>
            <PlayerSectionHeader>
                <FormattedMessage defaultMessage="Awards" description="A header describing a player's awards" />
            </PlayerSectionHeader>

            {awardList}
        </>
    ) : null;
};
